import { StateType } from '../../types';

export const getMakePaymentClientSecret = (state: StateType) =>
  state.deferredPayments.makePayment.clientSecret;
export const getMakePaymentLoading = (state: StateType) =>
  state.deferredPayments.makePayment.loading;
export const getMakePaymentError = (state: StateType) => state.deferredPayments.makePayment.error;
export const getMakePaymentSuccess = (state: StateType) =>
  state.deferredPayments.makePayment.success;
export const getMakePaymentUnknownState = (state: StateType) =>
  state.deferredPayments.makePayment.unknownState;
